import styled from "styled-components";

interface ITextToCopy {
	$maxWidth: string;
}
export const TextToCopy = styled.div<ITextToCopy>`
	display: flex;
	flex-direction: row;
	width: 100%;
	max-width: ${({ $maxWidth }) => $maxWidth};
	user-select: none;
	cursor: pointer;
	gap: 10px;
	margin-right: 11px;

	> svg {
		color: ${({ theme }) => theme.pantone2726C};
	}
`;
